// extracted by mini-css-extract-plugin
export default {"savings":"RefiOptionHeader_savings__TRSK7","armCaution":"RefiOptionHeader_armCaution__wmDSs"};